import { call, put, takeLatest } from "redux-saga/effects";
import { authAPI } from "../../../services/auth/index"
import { verifyAccount, VERIFY_ACCOUNT } from "../../actions/auth.action"

function* handleVerifyLogin(action) {
  try {
    const { data : resData} = yield call(authAPI.verifyAccount, action.payload);
    //extract the data here     
    yield put(verifyAccount.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(verifyAccount.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* verifyAccountSaga() {
  yield takeLatest(VERIFY_ACCOUNT.REQUEST, handleVerifyLogin);
}

export default verifyAccountSaga;
